// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27black%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-card {
  padding: 15px;
  margin: 10px 0 20px;
  background: var(--primary-background-color);
  position: relative;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 0.375rem;
}
.case-card .card-top {
  display: flex;
  align-items: center;
}
.case-card .card-top input[type=checkbox] {
  background-color: var(--primary-color);
}
.case-card .card-top .serial-number {
  background-color: var(--primary-background-color);
  font-size: 15px;
  font-weight: 600;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.case-card .card-top .serial-no-checkboxes {
  margin-left: 10px;
}
.case-card .card-top .card-header-content {
  flex: 1 1;
  margin-left: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.case-card .card-top .card-header-content .parties-title {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.case-card .card-top .card-header-content .parties-title .label-pill {
  background: var(--label-color);
  color: var(--text-color);
  padding: 2px 10px;
  font-size: 12px;
  border-radius: 4px;
  margin-left: 10px;
  justify-content: center;
  display: flex;
  align-items: center;
}
.case-card .card-top .card-header-content .parties-title .bubble-notification {
  background-color: crimson;
  color: white;
  font-size: 11px;
  font-weight: bold;
  border-radius: 50%;
  padding: 2px 7px;
  margin-left: 8px;
  animation: popIn 0.3s ease-in-out;
}
@keyframes popIn {
  from {
    transform: scale(0.6);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.case-card .card-top .card-header-content .files-status {
  display: flex;
  align-items: center;
}
.case-card .card-top .card-header-content .files-status .filed-on {
  font-size: 12px;
  color: #555;
  margin-right: 10px;
}
.case-card .card-top .card-header-content .files-status .status-pill {
  background: var(--status-color);
  color: var(--text-color);
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 3px;
}
.case-card .card-top .card-header-content .files-status .status-pill.disposed {
  background: var(--secondary-background-color);
}
.case-card .card-top .reappeal-btn {
  background-color: var(--success-color);
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  margin-left: 10px;
  transition: all 0.2s ease;
}
.case-card .card-top .reappeal-btn:active {
  transform: scale(0.95);
}
.case-card .card-top .reappeal-btn.has-data {
  background-color: var(--primary-light-color);
}
.case-card .case-meta {
  margin-top: 20px;
  margin-left: 20px;
  font-size: 13px;
  color: var(--text-color-second);
  display: flex;
  justify-content: space-between;
}
.case-card .case-meta-main .case-meta-details {
  display: flex;
  align-items: center;
}
.case-card .case-meta-main .case-meta-details p:not(:first-child) {
  margin-left: 2px;
}
.case-card .case-meta-main .case-meta-details .case-card-detail {
  color: var(--text-color-fourth);
}
.case-card .case-meta-main-assigned {
  background: linear-gradient(135deg, #f0f9ff 0%, #eef2ff 100%);
  border: 1px solid #bae6fd;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 120px;
}
.case-card .case-meta-main-assigned .assigned-to-label, .case-card .case-meta-main-assigned .advocate-name {
  color: var(--primary-color);
}
.case-card .case-meta-mob-edit .edit-btn-assign {
  margin-left: auto;
  padding: 3px 6px;
  border: 1px solid #ccc;
  border-radius: 50px;
  background-color: #fff;
  cursor: pointer;
  font-size: 12px;
  color: #333;
}
.case-card .case-meta-mob-edit .edit-btn-assign:hover {
  background-color: #eee;
}
.case-card .case-meta-mob-edit .edit-btn-assign.mobile-edit {
  display: none;
  margin-top: 10px;
}
.case-card hr {
  margin: 20px 0;
}
.case-card .court-details {
  display: flex;
  justify-content: space-between;
}
.case-card .court-details .case-meta-court {
  margin-left: 20px;
  font-size: 13px;
  color: var(--text-color-second);
}
.case-card .bottom-bar {
  display: flex;
  border-radius: 6px;
}
.case-card .bottom-bar .date-box,
.case-card .bottom-bar .assigned-box {
  background: #e2e8f0;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 10px;
  height: fit-content;
  position: relative;
}
.case-card .bottom-bar .date-box .custom-date,
.case-card .bottom-bar .assigned-box .custom-date {
  color: #059669;
  font-weight: 500;
}
.case-card .bottom-bar .date-box .custom-date-badge,
.case-card .bottom-bar .assigned-box .custom-date-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #10b981;
  color: white;
  font-size: 10px;
  font-weight: bold;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  cursor: help;
}
.case-card .bottom-bar .reappeal-info-bottom {
  display: flex;
  gap: 10px;
  margin-right: 10px;
}
.case-card .bottom-bar .reappeal-info-bottom .reappeal-item-bottom {
  background: linear-gradient(135deg, #f0f9ff 0%, #eef2ff 100%);
  border: 1px solid #bae6fd;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 120px;
}
.case-card .bottom-bar .reappeal-info-bottom .reappeal-item-bottom p {
  margin: 0;
}
.case-card .bottom-bar .reappeal-info-bottom .reappeal-item-bottom p:first-child {
  color: var(--primary-color);
  font-weight: 600;
}
.case-card .bottom-bar .reappeal-info-bottom .reappeal-item-bottom p:last-child {
  color: var(--primary-color);
  font-weight: 500;
}
.case-card .bottom-bar .fetched-case-assigned {
  margin-right: 0px;
}
.case-card .bottom-bar .actions-case-card {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.case-card .bottom-bar .actions-case-card .edit-btn-assign {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 50px;
  background-color: #fff;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
}
.case-card .bottom-bar .actions-case-card .edit-btn-assign:hover {
  background-color: #eee;
}
.case-card .expand-toggle-bottom {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}
.case-card .expand-toggle-bottom .circle-arrow {
  width: 20px;
  height: 20px;
  background-color: rgba(196, 196, 196, 0.7);
  color: var(--text-color-fourth);
  border-radius: 50%;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid white;
  transition: transform 0.3s ease;
}
.case-card .expand-toggle-bottom .circle-arrow.up {
  transform: rotate(180deg);
}
.case-card .card-details {
  transition: max-height 0.3s ease-in-out;
  border-top: 1px solid #eee;
}
.case-card .card-details .card-det-div {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  padding: 15px;
}
.case-card .card-details .card-det-div .card-section {
  flex: 1 1;
}
.case-card .card-details .card-det-div .docs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 13px;
  width: 100%;
}
.case-card .card-details .card-det-div .case-extend-details-card {
  padding: 10px;
  border-radius: 6px;
  background-color: #e2e8f0;
  margin-top: 10px;
}

.search-highlight {
  background-color: yellow;
  color: black;
  font-weight: bold;
  border-radius: 2px;
  padding: 0 2px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease-out;
  padding: 20px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.reappeal-modal {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out;
  overflow: hidden;
}
.reappeal-modal .modal-header {
  padding: 24px 24px 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
}
.reappeal-modal .modal-header h3 {
  margin: 0;
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
}
.reappeal-modal .modal-header .close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  line-height: 1;
}
.reappeal-modal .modal-header .close-btn:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.reappeal-modal .modal-header .close-btn:active {
  transform: scale(0.95);
}
.reappeal-modal .modal-body {
  padding: 24px;
}
.reappeal-modal .modal-body form {
  display: flex;
  flex-direction: column;
}
.reappeal-modal .modal-body .form-group {
  margin-bottom: 24px;
}
.reappeal-modal .modal-body .form-group:last-of-type {
  margin-bottom: 32px;
}
.reappeal-modal .modal-body .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}
.reappeal-modal .modal-body .form-group input[type=number] {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
  background-color: white;
  color: #1f2937;
  box-sizing: border-box;
}
.reappeal-modal .modal-body .form-group input[type=number]:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.reappeal-modal .modal-body .form-group input[type=number]::placeholder {
  color: #9ca3af;
}
.reappeal-modal .modal-body .form-group input[type=number]::-webkit-outer-spin-button, .reappeal-modal .modal-body .form-group input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.reappeal-modal .modal-body .form-group input[type=number][type=number] {
  -moz-appearance: textfield;
}
.reappeal-modal .modal-body .form-group input[type=text] {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
  background-color: white;
  color: #1f2937;
  box-sizing: border-box;
}
.reappeal-modal .modal-body .form-group input[type=text]:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.reappeal-modal .modal-body .form-group input[type=text]::placeholder {
  color: #9ca3af;
}
.reappeal-modal .modal-body .form-group input[type=text]::-webkit-outer-spin-button, .reappeal-modal .modal-body .form-group input[type=text]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.reappeal-modal .modal-body .form-group .date-select-container {
  display: flex;
  gap: 10px;
  width: 100%;
}
.reappeal-modal .modal-body .form-group select.date-select {
  flex: 1 1;
  padding: 12px 10px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  background-color: white;
  color: #1f2937;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 50%;
}
.reappeal-modal .modal-body .form-group select.date-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.reappeal-modal .modal-body .form-group .calculated-date-display {
  margin-top: 12px;
  padding: 10px;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  text-align: center;
  font-size: 14px;
  color: #374151;
}
.reappeal-modal .modal-body .form-group .calculated-date-display strong {
  color: #1d4ed8;
  font-weight: 600;
}
.reappeal-modal .modal-body .form-group .calculated-date {
  padding: 16px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  animation: slideInDate 0.3s ease-out;
}
@keyframes slideInDate {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.reappeal-modal .modal-body .modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 0;
}
.reappeal-modal .modal-body .modal-actions button {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  min-width: 110px;
}
.reappeal-modal .modal-body .modal-actions button.cancel-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
  background-color: #dc2626;
  color: white;
}
.reappeal-modal .modal-body .modal-actions button.cancel-btn:hover {
  background-color: #b91c1c;
}
.reappeal-modal .modal-body .modal-actions button.cancel-btn:active {
  transform: scale(0.98);
}
.reappeal-modal .modal-body .modal-actions button.submit-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
  background-color: #16a34a;
  color: white;
}
.reappeal-modal .modal-body .modal-actions button.submit-btn:hover:not(:disabled) {
  background-color: #15803d;
}
.reappeal-modal .modal-body .modal-actions button.submit-btn:active:not(:disabled) {
  transform: translateY(0);
}
.reappeal-modal .modal-body .modal-actions button.submit-btn:disabled {
  background: #d1d5db;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

@keyframes slideIn {
  from {
    transform: translateY(-30px) scale(0.95);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .case-card {
    padding: 10px;
  }
  .case-card .card-top {
    align-items: flex-start;
  }
  .case-card .card-top .reappeal-btn {
    width: 24px;
    height: 24px;
    font-size: 14px;
    margin-left: 8px;
    margin-top: 5px;
  }
  .case-card .card-top .card-header-content {
    flex-direction: column;
    align-items: flex-start;
  }
  .case-card .card-top .card-header-content .parties-title {
    font-size: 12px;
    align-items: flex-start;
  }
  .case-card .card-top .card-header-content .parties-title .label-pill {
    font-size: 11px;
  }
  .case-card .card-top .card-header-content .files-status {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 10px;
  }
  .case-card .card-top .card-header-content .files-status .filed-on {
    font-size: 12px;
  }
  .case-card .card-top .card-header-content .files-status .status-pill {
    margin: 2px 0;
    font-size: 11px;
  }
  .case-card .court-details {
    justify-content: end;
  }
  .case-card .case-meta {
    justify-content: space-between;
    align-items: end;
    margin-left: 23px;
    margin-top: 10px;
  }
  .case-card .case-meta-main .case-meta-details {
    margin-left: 0 !important;
    font-size: 13px;
  }
  .case-card .case-meta-main .case-meta-details p:not(:first-child) {
    font-size: 13px;
  }
  .case-card .case-meta-main .case-meta-details .case-card-detail {
    font-size: 13px;
  }
  .case-card .case-meta-mob-edit .mobile-edit {
    display: flex !important;
    align-self: flex-end;
    margin-top: 10px;
    margin-right: 10px;
  }
  .case-card .expand-toggle-bottom,
  .case-card .card-details,
  .case-card .case-meta-court,
  .case-card hr,
  .case-card .date-box,
  .case-card .assigned-box,
  .case-card .reappeal-info-bottom,
  .case-card .bottom-bar {
    display: none !important;
  }
  .reappeal-modal {
    width: 95%;
    margin: 20px;
  }
  .reappeal-modal .modal-body .modal-actions {
    flex-direction: column;
  }
  .reappeal-modal .modal-body .modal-actions button {
    width: 100%;
    margin-bottom: 8px;
  }
  .reappeal-modal .modal-body .modal-actions button:last-child {
    margin-bottom: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CaseCard/CaseCard.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,2CAAA;EAEA,kBAAA;EACA,eAAA;EAEA,sBAAA;EACA,uBAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;AADJ;AAGI;EACE,sCAAA;AADN;AAII;EACE,iDAAA;EAEA,eAAA;EACA,gBAAA;EAEA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,cAAA;AANN;AASI;EACE,iBAAA;AAPN;AAUI;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AARN;AAUM;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AARR;AAUQ;EACE,8BAAA;EACA,wBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AARV;AAWQ;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;AATV;AAaQ;EACE;IACE,qBAAA;IACA,UAAA;EAXV;EAcQ;IACE,mBAAA;IACA,UAAA;EAZV;AACF;AAgBM;EACE,aAAA;EACA,mBAAA;AAdR;AAgBQ;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AAdV;AAiBQ;EACE,+BAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAfV;AAiBU;EACE,6CAAA;AAfZ;AAqBI;EACE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAnBN;AAqBM;EACE,sBAAA;AAnBR;AAsBM;EACE,4CAAA;AApBR;AA0BE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,+BAAA;EACA,aAAA;EACA,8BAAA;AAxBJ;AA2BM;EACE,aAAA;EACA,mBAAA;AAzBR;AA4BU;EACE,gBAAA;AA1BZ;AA8BQ;EACE,+BAAA;AA5BV;AAqCI;EACE,6DAAA;EACF,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAnCJ;AAqCI;EACE,2BAAA;AAnCN;AAyCM;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AAvCR;AAyCQ;EACE,sBAAA;AAvCV;AA0CQ;EACE,aAAA;EACA,gBAAA;AAxCV;AA8CE;EACE,cAAA;AA5CJ;AA+CE;EACE,aAAA;EAEA,8BAAA;AA9CJ;AAgDI;EACE,iBAAA;EACA,eAAA;EACA,+BAAA;AA9CN;AAsDE;EACE,aAAA;EAEA,kBAAA;AArDJ;AAwDI;;EAEE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAtDN;AAyDM;;EACE,cAAA;EACA,gBAAA;AAtDR;AAyDM;;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAtDR;AA+DI;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AA7DN;AA+DM;EACE,6DAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AA7DR;AA+DQ;EACE,SAAA;AA7DV;AA+DU;EACE,2BAAA;EACA,gBAAA;AA7DZ;AAgEU;EACE,2BAAA;EACA,gBAAA;AA9DZ;AAoEI;EACE,iBAAA;AAlEN;AAqEI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAnEN;AAoEM;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnER;AAqEQ;EACE,sBAAA;AAnEV;AAyEE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;AAvEJ;AAyEI;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;AAvEN;AAyEM;EACE,yBAAA;AAvER;AA4EE;EACE,uCAAA;EACA,0BAAA;AA1EJ;AA4EI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EAEA,eAAA;EACA,aAAA;AA3EN;AA6EM;EACE,SAAA;AA3ER;AA+EM;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,WAAA;AA7ER;AAgFM;EACE,aAAA;EAEA,kBAAA;EACA,yBAAA;EACA,gBAAA;AA/ER;;AAuFA;EACE,wBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AApFF;;AAoGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;AAjGF;;AAoGA;EACE;IACE,UAAA;EAjGF;EAmGA;IACE,UAAA;EAjGF;AACF;AAoGA;EACE,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,2CAAA;EACA,gCAAA;EACA,gBAAA;AAlGF;AAoGE;EACE,4BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;AAlGJ;AAoGI;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAlGN;AAqGI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAnGN;AAqGM;EACE,yBAAA;EACA,cAAA;AAnGR;AAsGM;EACE,sBAAA;AApGR;AAyGE;EACE,aAAA;AAvGJ;AAyGI;EACE,aAAA;EACA,sBAAA;AAvGN;AA0GI;EACE,mBAAA;AAxGN;AA0GM;EACE,mBAAA;AAxGR;AA2GM;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAzGR;AA6GM;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AA3GR;AA6GQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA3GV;AA8GQ;EACE,cAAA;AA5GV;AA+GQ;EAEE,wBAAA;EACA,SAAA;AA9GV;AAiHQ;EACE,0BAAA;AA/GV;AAkHM;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AAhHR;AAkHQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAhHV;AAmHQ;EACE,cAAA;AAjHV;AAoHQ;EAEE,wBAAA;EACA,SAAA;AAnHV;AA0HM;EACE,aAAA;EACA,SAAA;EACA,WAAA;AAxHR;AA2HM;EACE,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BAAA;AAzHR;AA2HQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAzHV;AA6HM;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA3HR;AA6HQ;EACE,cAAA;EACA,gBAAA;AA3HV;AA+HM;EACE,aAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,8CAAA;EACA,oCAAA;AA7HR;AAgIM;EACE;IACE,UAAA;IACA,4BAAA;EA9HR;EAgIM;IACE,UAAA;IACA,wBAAA;EA9HR;AACF;AAkII;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AAhIN;AAkIM;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAhIR;AAkIQ;EAIE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAnIV;AAqIU;EACE,yBAAA;AAnIZ;AAuIU;EACE,sBAAA;AArIZ;AAyIQ;EAIE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AA1IV;AAiJU;EACE,yBAAA;AA/IZ;AAkJU;EACE,wBAAA;AAhJZ;AAmJU;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAjJZ;;AAyJA;EACE;IACE,wCAAA;IACA,UAAA;EAtJF;EAwJA;IACE,iCAAA;IACA,UAAA;EAtJF;AACF;AAyJA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAvJF;;AA0JA;EACE,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AAvJF;;AA0JA;EACE;IACE,uBAAA;EAvJF;EA0JA;IACE,yBAAA;EAxJF;AACF;AA2JA;EACE;IACE,aAAA;EAzJF;EA2JE;IAEE,uBAAA;EA1JJ;EA4JI;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;EA1JN;EA6JI;IACE,sBAAA;IACA,uBAAA;EA3JN;EA6JM;IACE,eAAA;IACA,uBAAA;EA3JR;EA6JQ;IACE,eAAA;EA3JV;EA+JM;IACE,sBAAA;IACA,uBAAA;IACA,gBAAA;EA7JR;EA+JQ;IACE,eAAA;EA7JV;EAgKQ;IACE,aAAA;IACA,eAAA;EA9JV;EAoKE;IACE,oBAAA;EAlKJ;EAqKE;IACE,8BAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;EAnKJ;EAsKM;IACE,yBAAA;IACA,eAAA;EApKR;EAuKU;IACE,eAAA;EArKZ;EAyKQ;IACE,eAAA;EAvKV;EA6KM;IACE,wBAAA;IACA,oBAAA;IACA,gBAAA;IACA,kBAAA;EA3KR;EAgLE;;;;;;;;IAQE,wBAAA;EA9KJ;EAmLA;IACE,UAAA;IACA,YAAA;EAjLF;EAoLI;IACE,sBAAA;EAlLN;EAoLM;IACE,WAAA;IACA,kBAAA;EAlLR;EAoLQ;IACE,gBAAA;EAlLV;AACF","sourcesContent":[".case-card {\r\n  padding: 15px;\r\n  margin: 10px 0 20px;\r\n  background: var(--primary-background-color);\r\n  // font-family: sans-serif;\r\n  position: relative;\r\n  cursor: pointer;\r\n  // box-shadow: 0 1px 3px var(--boxshadow-color);\r\n  border: 1px solid #ddd;\r\n  border-radius: 0.375rem;\r\n\r\n  .card-top {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    input[type=\"checkbox\"] {\r\n      background-color: var(--primary-color);\r\n    }\r\n\r\n    .serial-number {\r\n      background-color: var(--primary-background-color);\r\n      //color: white;\r\n      font-size: 15px;\r\n      font-weight: 600;\r\n      //width: 24px;\r\n      height: 24px;\r\n      //border-radius: 50%;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      //margin-right: 10px;\r\n      flex-shrink: 0;\r\n    }\r\n\r\n    .serial-no-checkboxes{\r\n      margin-left: 10px;\r\n    }\r\n\r\n    .card-header-content {\r\n      flex: 1;\r\n      margin-left: 7px;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n\r\n      .parties-title {\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        .label-pill {\r\n          background: var(--label-color);\r\n          color: var(--text-color);\r\n          padding: 2px 10px;\r\n          font-size: 12px;\r\n          border-radius: 4px;\r\n          margin-left: 10px;\r\n          justify-content: center;\r\n          display: flex;\r\n          align-items: center;\r\n        }\r\n\r\n        .bubble-notification {\r\n          background-color: crimson;\r\n          color: white;\r\n          font-size: 11px;\r\n          font-weight: bold;\r\n          border-radius: 50%;\r\n          padding: 2px 7px;\r\n          margin-left: 8px;\r\n          animation: popIn 0.3s ease-in-out;\r\n          // box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\r\n        }\r\n\r\n        @keyframes popIn {\r\n          from {\r\n            transform: scale(0.6);\r\n            opacity: 0;\r\n          }\r\n\r\n          to {\r\n            transform: scale(1);\r\n            opacity: 1;\r\n          }\r\n        }\r\n      }\r\n\r\n      .files-status {\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        .filed-on {\r\n          font-size: 12px;\r\n          color: #555;\r\n          margin-right: 10px;\r\n        }\r\n\r\n        .status-pill {\r\n          background: var(--status-color);\r\n          color: var(--text-color);\r\n          font-size: 12px;\r\n          padding: 3px 6px;\r\n          border-radius: 3px;\r\n\r\n          &.disposed {\r\n            background: var(--secondary-background-color);\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .reappeal-btn {\r\n      background-color: var(--success-color);\r\n      color: white;\r\n      border: none;\r\n      border-radius: 50%;\r\n      width: 28px;\r\n      height: 28px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      cursor: pointer;\r\n      font-size: 16px;\r\n      margin-left: 10px;\r\n      transition: all 0.2s ease;\r\n\r\n      &:active {\r\n        transform: scale(0.95);\r\n      }\r\n\r\n      &.has-data {\r\n        background-color: var(--primary-light-color);\r\n\r\n      }\r\n    }\r\n  }\r\n\r\n  .case-meta {\r\n    margin-top: 20px;\r\n    margin-left: 20px;\r\n    font-size: 13px;\r\n    color: var(--text-color-second);\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    &-main {\r\n      .case-meta-details {\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        p {\r\n          &:not(:first-child) {\r\n            margin-left: 2px;\r\n          }\r\n        }\r\n\r\n        .case-card-detail {\r\n          color: var(--text-color-fourth);\r\n        }\r\n\r\n        // &:not(:first-child) {\r\n        //   margin-left: 10px;\r\n        // }\r\n      }\r\n    }\r\n\r\n    &-main-assigned{\r\n      background: linear-gradient(135deg, #f0f9ff 0%, #eef2ff 100%);\r\n    border: 1px solid #bae6fd;\r\n    padding: 10px;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    min-width: 120px;\r\n\r\n    .assigned-to-label , .advocate-name{\r\n      color: var(--primary-color);\r\n    }\r\n\r\n    }\r\n\r\n    &-mob-edit {\r\n      .edit-btn-assign {\r\n        margin-left: auto;\r\n        padding: 3px 6px;\r\n        border: 1px solid #ccc;\r\n        border-radius: 50px;\r\n        background-color: #fff;\r\n        cursor: pointer;\r\n        font-size: 12px;\r\n        color: #333;\r\n\r\n        &:hover {\r\n          background-color: #eee;\r\n        }\r\n\r\n        &.mobile-edit {\r\n          display: none;\r\n          margin-top: 10px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  hr {\r\n    margin: 20px 0;\r\n  }\r\n\r\n  .court-details {\r\n    display: flex;\r\n    // margin-bottom: 20px;\r\n    justify-content: space-between;\r\n\r\n    .case-meta-court {\r\n      margin-left: 20px;\r\n      font-size: 13px;\r\n      color: var(--text-color-second);\r\n\r\n      // .courtnames {\r\n      //   font-size: medium;\r\n      // }\r\n    }\r\n  }\r\n\r\n  .bottom-bar {\r\n    display: flex;\r\n    // padding: 10px;\r\n    border-radius: 6px;\r\n    // align-items: center;\r\n\r\n    .date-box,\r\n    .assigned-box {\r\n      background: #e2e8f0;\r\n      padding: 10px;\r\n      border-radius: 4px;\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      margin-right: 10px;\r\n      height: fit-content;\r\n      position: relative;\r\n      \r\n      // Custom date styling - simple green color\r\n      .custom-date {\r\n        color: #059669;\r\n        font-weight: 500;\r\n      }\r\n\r\n      .custom-date-badge {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        background: #10b981;\r\n        color: white;\r\n        font-size: 10px;\r\n        font-weight: bold;\r\n        border-radius: 50%;\r\n        width: 16px;\r\n        height: 16px;\r\n        margin-left: 4px;\r\n        cursor: help;\r\n      }\r\n      // p {\r\n      //   margin-block-start: 0.5em !important;\r\n      //   margin-block-end: 0.5em !important;\r\n      // }\r\n    }\r\n\r\n    // Re-Appeal Info Display in Bottom Bar\r\n    .reappeal-info-bottom {\r\n      display: flex;\r\n      gap: 10px;\r\n      margin-right: 10px;\r\n\r\n      .reappeal-item-bottom {\r\n        background: linear-gradient(135deg, #f0f9ff 0%, #eef2ff 100%);\r\n        border: 1px solid #bae6fd;\r\n        padding: 10px;\r\n        border-radius: 4px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        min-width: 120px;\r\n\r\n        p {\r\n          margin: 0;\r\n\r\n          &:first-child {\r\n            color: var(--primary-color);\r\n            font-weight: 600;\r\n          }\r\n\r\n          &:last-child {\r\n            color: var(--primary-color);\r\n            font-weight: 500;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .fetched-case-assigned {\r\n      margin-right: 0px;\r\n    }\r\n\r\n    .actions-case-card {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 2px;\r\n      .edit-btn-assign {\r\n        // margin-left: auto;\r\n        padding: 10px;\r\n        border: 1px solid #ccc;\r\n        border-radius: 50px;\r\n        background-color: #fff;\r\n        cursor: pointer;\r\n        font-size: 16px;\r\n        color: #333;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        &:hover {\r\n          background-color: #eee;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .expand-toggle-bottom {\r\n    position: absolute;\r\n    bottom: -10px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    z-index: 2;\r\n\r\n    .circle-arrow {\r\n      width: 20px;\r\n      height: 20px;\r\n      background-color: rgba(196, 196, 196, 0.7);\r\n      color: var(--text-color-fourth);\r\n      border-radius: 50%;\r\n      font-size: 14px;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      border: 2px solid white;\r\n      transition: transform 0.3s ease;\r\n\r\n      &.up {\r\n        transform: rotate(180deg);\r\n      }\r\n    }\r\n  }\r\n\r\n  .card-details {\r\n    transition: max-height 0.3s ease-in-out;\r\n    border-top: 1px solid #eee;\r\n\r\n    .card-det-div {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      gap: 20px;\r\n      // width: 100%;\r\n      flex-wrap: wrap;\r\n      padding: 15px;\r\n\r\n      .card-section {\r\n        flex: 1;\r\n        // min-width: 250px;\r\n      }\r\n\r\n      .docs-grid {\r\n        display: grid;\r\n        grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));\r\n        gap: 13px;\r\n        width: 100%;\r\n      }\r\n\r\n      .case-extend-details-card {\r\n        padding: 10px;\r\n        // border: px solid #000;\r\n        border-radius: 6px;\r\n        background-color: #e2e8f0;\r\n        margin-top: 10px;\r\n        // width: 80%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Add this anywhere in the file\r\n.search-highlight {\r\n  background-color: yellow;\r\n  color: black;\r\n  font-weight: bold;\r\n  border-radius: 2px;\r\n  padding: 0 2px;\r\n}\r\n// .card-header-content {\r\n//   transition: margin-left 0.2s ease;\r\n// }\r\n\r\n// .case-card .card-top input[type=\"checkbox\"] {\r\n//   animation: fadeIn 0.2s ease-in;\r\n// }\r\n\r\n// @keyframes fadeIn {\r\n//   from { opacity: 0; transform: scale(0.8); }\r\n//   to { opacity: 1; transform: scale(1); }\r\n// }\r\n\r\n// Re-Appeal Modal Styles\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.6);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n  animation: fadeIn 0.2s ease-out;\r\n  padding: 20px;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.reappeal-modal {\r\n  background: white;\r\n  border-radius: 12px;\r\n  width: 100%;\r\n  max-width: 480px;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\r\n  animation: slideIn 0.3s ease-out;\r\n  overflow: hidden;\r\n\r\n  .modal-header {\r\n    padding: 24px 24px 16px 24px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-bottom: 1px solid #e5e7eb;\r\n\r\n    h3 {\r\n      margin: 0;\r\n      color: #1f2937;\r\n      font-size: 20px;\r\n      font-weight: 600;\r\n    }\r\n\r\n    .close-btn {\r\n      background: none;\r\n      border: none;\r\n      font-size: 28px;\r\n      cursor: pointer;\r\n      color: #6b7280;\r\n      padding: 0;\r\n      width: 32px;\r\n      height: 32px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: 50%;\r\n      transition: all 0.2s ease;\r\n      line-height: 1;\r\n\r\n      &:hover {\r\n        background-color: #f3f4f6;\r\n        color: #374151;\r\n      }\r\n\r\n      &:active {\r\n        transform: scale(0.95);\r\n      }\r\n    }\r\n  }\r\n\r\n  .modal-body {\r\n    padding: 24px;\r\n\r\n    form {\r\n      display: flex;\r\n      flex-direction: column;\r\n    }\r\n\r\n    .form-group {\r\n      margin-bottom: 24px;\r\n\r\n      &:last-of-type {\r\n        margin-bottom: 32px;\r\n      }\r\n\r\n      label {\r\n        display: block;\r\n        margin-bottom: 8px;\r\n        font-weight: 600;\r\n        color: #374151;\r\n        font-size: 14px;\r\n      }\r\n      \r\n\r\n      input[type=\"number\"] {\r\n        width: 100%;\r\n        padding: 12px 16px;\r\n        border: 2px solid #d1d5db;\r\n        border-radius: 8px;\r\n        font-size: 16px;\r\n        transition: all 0.2s ease;\r\n        background-color: white;\r\n        color: #1f2937;\r\n        box-sizing: border-box;\r\n\r\n        &:focus {\r\n          outline: none;\r\n          border-color: #3b82f6;\r\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n        }\r\n\r\n        &::placeholder {\r\n          color: #9ca3af;\r\n        }\r\n\r\n        &::-webkit-outer-spin-button,\r\n        &::-webkit-inner-spin-button {\r\n          -webkit-appearance: none;\r\n          margin: 0;\r\n        }\r\n\r\n        &[type=\"number\"] {\r\n          -moz-appearance: textfield;\r\n        }\r\n      }\r\n      input[type=\"text\"] {\r\n        width: 100%;\r\n        padding: 12px 16px;\r\n        border: 2px solid #d1d5db;\r\n        border-radius: 8px;\r\n        font-size: 16px;\r\n        transition: all 0.2s ease;\r\n        background-color: white;\r\n        color: #1f2937;\r\n        box-sizing: border-box;\r\n\r\n        &:focus {\r\n          outline: none;\r\n          border-color: #3b82f6;\r\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n        }\r\n\r\n        &::placeholder {\r\n          color: #9ca3af;\r\n        }\r\n\r\n        &::-webkit-outer-spin-button,\r\n        &::-webkit-inner-spin-button {\r\n          -webkit-appearance: none;\r\n          margin: 0;\r\n        }\r\n\r\n        \r\n      }\r\n      \r\n      // --- New Styles for Date Selectors ---\r\n      .date-select-container {\r\n        display: flex;\r\n        gap: 10px;\r\n        width: 100%;\r\n      }\r\n\r\n      select.date-select {\r\n        flex: 1;\r\n        padding: 12px 10px;\r\n        border: 2px solid #d1d5db;\r\n        border-radius: 8px;\r\n        font-size: 14px;\r\n        transition: all 0.2s ease;\r\n        background-color: white;\r\n        color: #1f2937;\r\n        box-sizing: border-box;\r\n        -webkit-appearance: none;\r\n        -moz-appearance: none;\r\n        background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\r\n        background-repeat: no-repeat;\r\n        background-position-x: 95%;\r\n        background-position-y: 50%;\r\n\r\n        &:focus {\r\n          outline: none;\r\n          border-color: #3b82f6;\r\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n        }\r\n      }\r\n\r\n      .calculated-date-display {\r\n        margin-top: 12px;\r\n        padding: 10px;\r\n        background-color: #f3f4f6;\r\n        border: 1px solid #e5e7eb;\r\n        border-radius: 6px;\r\n        text-align: center;\r\n        font-size: 14px;\r\n        color: #374151;\r\n\r\n        strong {\r\n          color: #1d4ed8;\r\n          font-weight: 600;\r\n        }\r\n      }\r\n\r\n      .calculated-date {\r\n        padding: 16px;\r\n        background: linear-gradient(135deg, #10b981 0%, #059669 100%);\r\n        color: white;\r\n        border-radius: 8px;\r\n        font-weight: 600;\r\n        text-align: center;\r\n        font-size: 16px;\r\n        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\r\n        animation: slideInDate 0.3s ease-out;\r\n      }\r\n\r\n      @keyframes slideInDate {\r\n        from {\r\n          opacity: 0;\r\n          transform: translateY(-10px);\r\n        }\r\n        to {\r\n          opacity: 1;\r\n          transform: translateY(0);\r\n        }\r\n      }\r\n    }\r\n\r\n    .modal-actions {\r\n      display: flex;\r\n      gap: 12px;\r\n      justify-content: flex-end;\r\n      margin-top: 0;\r\n\r\n      button {\r\n        padding: 12px 24px;\r\n        border: none;\r\n        border-radius: 8px;\r\n        cursor: pointer;\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        transition: all 0.2s ease;\r\n        min-width: 110px;\r\n\r\n        &.cancel-btn {\r\n          // background-color: #f9fafb;\r\n          // color: #6b7280;\r\n          // border: 2px solid #e5e7eb;\r\n          padding: 0.75rem 1.5rem;\r\n          border: none;\r\n          border-radius: 0.375rem;\r\n          font-size: 0.875rem;\r\n          font-weight: 500;\r\n          cursor: pointer;\r\n          min-width: 120px;\r\n          transition: all 0.2s ease;\r\n          background-color: #dc2626;\r\n          color: white;\r\n\r\n          &:hover {\r\n            background-color: #b91c1c;\r\n            //border-color: #d1d5db;\r\n          }\r\n\r\n          &:active {\r\n            transform: scale(0.98);\r\n          }\r\n        }\r\n\r\n        &.submit-btn {\r\n          // background: linear-gradient(135deg, #10b981 0%, #059669 100%);\r\n          // color: white;\r\n          // box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\r\n          padding: 0.75rem 1.5rem;\r\n          border: none;\r\n          border-radius: 0.375rem;\r\n          font-size: 0.875rem;\r\n          font-weight: 500;\r\n          cursor: pointer;\r\n          min-width: 120px;\r\n          transition: all 0.2s ease;\r\n          background-color: #16a34a;\r\n          color: white;\r\n\r\n          // &:hover:not(:disabled) {\r\n          //   //transform: translateY(-1px);\r\n          //   box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);\r\n          // }\r\n\r\n          &:hover:not(:disabled) {\r\n            background-color: #15803d;\r\n          }\r\n\r\n          &:active:not(:disabled) {\r\n            transform: translateY(0);\r\n          }\r\n\r\n          &:disabled {\r\n            background: #d1d5db;\r\n            cursor: not-allowed;\r\n            opacity: 0.6;\r\n            transform: none;\r\n            box-shadow: none;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    transform: translateY(-30px) scale(0.95);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0) scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.loading-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.loading-spinner {\r\n  border: 4px solid rgba(0, 0, 0, 0.1);\r\n  border-top: 4px solid var(--primary-color);\r\n  border-radius: 50%;\r\n  width: 30px;\r\n  height: 30px;\r\n  animation: spin 2s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .case-card {\r\n    padding: 10px;\r\n\r\n    .card-top {\r\n      // flex-direction: column;\r\n      align-items: flex-start;\r\n\r\n      .reappeal-btn {\r\n        width: 24px;\r\n        height: 24px;\r\n        font-size: 14px;\r\n        margin-left: 8px;\r\n        margin-top: 5px;\r\n      }\r\n\r\n      .card-header-content {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n\r\n        .parties-title {\r\n          font-size: 12px;\r\n          align-items: flex-start;\r\n\r\n          .label-pill {\r\n            font-size: 11px;\r\n          }\r\n        }\r\n\r\n        .files-status {\r\n          flex-direction: column;\r\n          align-items: flex-start;\r\n          margin-top: 10px;\r\n\r\n          .filed-on {\r\n            font-size: 12px;\r\n          }\r\n\r\n          .status-pill {\r\n            margin: 2px 0;\r\n            font-size: 11px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .court-details {\r\n      justify-content: end;\r\n    }\r\n\r\n    .case-meta {\r\n      justify-content: space-between;\r\n      align-items: end;\r\n      margin-left: 23px;\r\n      margin-top: 10px;\r\n\r\n      &-main {\r\n        .case-meta-details {\r\n          margin-left: 0 !important;\r\n          font-size: 13px;\r\n\r\n          p {\r\n            &:not(:first-child) {\r\n              font-size: 13px;\r\n            }\r\n          }\r\n\r\n          .case-card-detail {\r\n            font-size: 13px;\r\n          }\r\n        }\r\n      }\r\n\r\n      &-mob-edit {\r\n        .mobile-edit {\r\n          display: flex !important;\r\n          align-self: flex-end;\r\n          margin-top: 10px;\r\n          margin-right: 10px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .expand-toggle-bottom,\r\n    .card-details,\r\n    .case-meta-court,\r\n    hr,\r\n    .date-box,\r\n    .assigned-box,\r\n    .reappeal-info-bottom,\r\n    .bottom-bar {\r\n      display: none !important;\r\n    }\r\n  }\r\n\r\n  // Mobile modal adjustments\r\n  .reappeal-modal {\r\n    width: 95%;\r\n    margin: 20px;\r\n\r\n    .modal-body {\r\n      .modal-actions {\r\n        flex-direction: column;\r\n\r\n        button {\r\n          width: 100%;\r\n          margin-bottom: 8px;\r\n\r\n          &:last-child {\r\n            margin-bottom: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
